/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import classNames from 'classnames';
import styles from './index.styl';

const Title = ({ className, colored, text }) => (
  <p
    className={classNames('ma0', className)}
    styleName={classNames('title', {
      'title--colored': colored,
    })}
    children={text}
  />
);

Title.propTypes = {
  className: PropTypes.string,
  colored: PropTypes.bool,
  text: PropTypes.string.isRequired,
};

export default CSSModules(Title, styles, { allowMultiple: true });



// WEBPACK FOOTER //
// ./src/components/Drawer/Title.jsx